module.exports = __webpack_public_path__ + "img/1549732645.9aae03f0.jpg";